import React from 'react';

import {isIE} from 'common/utils';
import {Marker} from 'common/components/BetterMap';
import userLocationIcon from 'common/components/icons/user-location.svg';
import userLocationIconBackup from 'common/components/icons/user-location.png';

const marker = isIE() ? userLocationIconBackup : userLocationIcon;

const UserLocationMarker = ({...props}) => (
  <Marker
    icon={{
      anchor: {x: 30, y: 30},
      size: {width: 60, height: 60},
      url: marker,
    }}
    animated
    {...props}
  />
);

export default UserLocationMarker;



// WEBPACK FOOTER //
// ./src/ondemand/components/UserLocationMarker.js